<template>
    <nav class="pagination is-right" role="navigation" aria-label="pagination">
        <ul class="pagination-list">
            <li class="pagination-link" v-if="pagination.current_page > 1">
            <a class="pagination-previous" aria-label="First" :href="endpoint + '/1'"><span aria-hidden="true">««</span></a>
            <a class="pagination-previous" aria-label="Previous" :href="endpoint + '/' + (pagination.current_page - 1)"><span aria-hidden="true">«</span></a>
            </li>

            <li v-for="page in pagesNumber" :class="getClass(page)">
                <span v-if="pagination.current_page === page" @click.prevent="preventClick">{{ page }}</span>
                <a v-else aria-label="Current" :href="endpoint + '/' + page">{{ page }}</a>
            </li>

            <li class="pagination-link" v-if="pagination.current_page < pagination.last_page">
                <a class="pagination-next" :href="endpoint + '/' + (pagination.current_page + 1)"><span aria-hidden="true">»</span></a>
                <a class="pagination-next" :href="endpoint + '/' + pagination.last_page"><span aria-hidden="true">»»</span></a>
            </li>
        </ul>
    </nav>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name:'app-pagination',
    props: {
        offset: {
            type: Number,
            default: 4
        },
        endpoint: {
            type: String
        }
    },
    data() {
        return {
            currentPage: '',
            href: '',
        };
    },

    computed: {
        ...mapGetters([
            'items',
            'paginate',
            'pagination',
            'error'
        ]),

        pagesNumber() {
            // if only one page, hide pagination
            if (this.pagination.current_page=== 1 && this.pagination.current_page === this.pagination.last_page) {
                return;
            }
            if (!this.pagination.to) {
                return [];
            }
            let from = this.pagination.current_page - this.offset;
            if (from < 1) {
                from = 1;
            }
            let to = from + (this.offset * 2);
            if (to >= this.pagination.last_page) {
                to = this.pagination.last_page;
            }
            let pagesArray = [];
            for (from = 1; from <= to; from++) {
                pagesArray.push(from);
            }

            return pagesArray;
        }
    },

    methods: {
        ...mapActions([
            'setPaginationCurrentPage',
        ]),

        getClass (item) {
          return this.pagination.current_page !== item ? 'pagination-link' : 'pagination-link is-current';
        },

        preventClick(event) {
            event.preventDefault();
            event.stopPropagation();
        }
    },
    mounted() {
        // console.log('pagination - Component mounted.');
    },
}

</script>

<style lang="scss">
    @import '../../../style/app.scss';
    nav.pagination {
        align-items: right;
        float: right;
        clear: both;
        // outline: 1px solid red;
        width: auto;
        height: 30px;
        margin-top: 0;
        z-index: 1;
    }
    .pagination-next, .pagination-previous {
        border-color: transparent !important;
        width: auto;
        // outline: 1px solid green;
        float: left;
        z-index:10;
        padding: 0;
        margin: 0;
        a {
            height: 100%;
            width: 100%;
            // outline: 1px solid green;
            float: left;
        }
    }
    ul.pagination-list {
        display: inline-block !important;
        height: 35px;
        margin-top: -5px;
        z-index: 10;
        margin-right: 10px;
        li {
            height: 100%;
            width: auto;
            // outline: 1px solid gray;
            float: left;
        }
    }
    li.pagination-link {
        border-color: transparent !important;
        border: none;
        min-width: 1.25em !important;
        padding: 0 !important;
        margin: 0.25rem 0 !important;
        width: auto;
        // outline: 1px solid green;
        float: left;
        a {
            height: 100%;
            width: 100%;
            float: left;
            margin: 0;
        }
        &.is-current {
            background: transparent !important;
            border-color: transparent;
            span {
                display: inline-block;
                width: 100%;
                height: 100%;
                color: $link-active !important;
                font-weight: bold;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/elements/pagination/Pagination.vue